import { z } from "zod";
import { metaSchema } from "./commun.zod";

export const ForfaitBaseSchema = z.object({
  name: z.string().min(1, "Le nom est requis").max(50, "Le nom ne peut pas dépasser 50 caractères").nullable().optional(),
  code_forfait: z.string().max(20, "Le code forfait ne peut pas dépasser 20 caractères").nullable().optional(),
});

export const ForfaitSchema = ForfaitBaseSchema.extend({
  id: z.number().int().positive(),
  created_at: z.date().nullable().optional(),
  updated_at: z.date().nullable().optional(),
});

export const ForfaitCreateSchema = ForfaitBaseSchema.pick({
  name: true,
  code_forfait: true,
});

export const ForfaitUpdateSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1, "Le nom est requis").max(50, "Le nom ne peut pas dépasser 50 caractères").nullable().optional(),
  code_forfait: z.string().max(20, "Le code forfait ne peut pas dépasser 20 caractères").nullable().optional(),
});

export const ForfaitListResponseSchema = z.object({
  data: z.array(ForfaitSchema),
   meta : metaSchema
});

export const ForfaitResponseSchema = z.object({
  data: ForfaitSchema,
  message: z.string().optional(),
});

export const ForfaitSelectSchema = z.object({
  id: z.number().int().positive().optional(),
  name: z.string().optional(),
  code_forfait: z.string().optional(),
});

export type Forfait = z.infer<typeof ForfaitSchema>;
export type ForfaitCreateInput = z.infer<typeof ForfaitCreateSchema>;
export type ForfaitUpdateInput = z.infer<typeof ForfaitUpdateSchema>;
export type ForfaitSelectInput = z.infer<typeof ForfaitSelectSchema>;

// Form-specific types for frontend
export type ForfaitFormData = ForfaitCreateInput;

export type ForfaitEditFormData = Omit<ForfaitUpdateInput, 'id'>;

// Utility types for different UI states
export type ForfaitDisplayItem = Pick<Forfait, 'id' | 'name' | 'code_forfait'>;
export type ForfaitSelectOption = Pick<Forfait, 'id' | 'name'>;
export type ForfaitTableItem = Pick<Forfait, 'id' | 'name' | 'code_forfait' | 'created_at' | 'updated_at'>;

export type ForfaitResponse = z.infer<typeof ForfaitResponseSchema>;
export type ForfaitListResponse = z.infer<typeof ForfaitListResponseSchema>;

export const validateForfaitCreate = (data: unknown) => {
  return ForfaitCreateSchema.safeParse(data);
};

export const validateForfaitUpdate = (data: unknown) => {
  return ForfaitUpdateSchema.omit({ id: true }).safeParse(data);
};

export const validateForfaitSelect = (data: unknown) => {
  return ForfaitSelectSchema.safeParse(data);
};
